import { cn } from '@/shared/lib/utils';

export interface VersionBadgeProps {
  readonly version: string;
  readonly className?: string;
}

/**
 * Version badge component
 * Displays current app version in the UI
 */
export function VersionBadge({ version, className }: VersionBadgeProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-border bg-muted px-3 py-1',
        className
      )}
    >
      <span className="font-mono text-xs text-muted-foreground">{version}</span>
    </div>
  );
}
